import React from 'react';
import { Content as ContentLayout } from 'components/layouts/content';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy connect (baseline)
import { connect } from 'react-redux';
import { isProspectMode } from 'selectors/user/user-features-selector';
import { NavBarWrapper } from './nav-bar.styled';

const NavBar = ({ children, prospectMode, ...properties }) => {
    return (
        // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
        <NavBarWrapper prospectMode={prospectMode} {...properties}>
            {!!prospectMode ? (
                <ContentLayout>{children}</ContentLayout>
            ) : (
                <ContentLayout inline fixed>
                    {children}
                </ContentLayout>
            )}
        </NavBarWrapper>
    );
};

const mapStateToProps = state => ({
    prospectMode: isProspectMode(state)
});

export default connect(mapStateToProps)(NavBar);
